import React from "react";
import Background from "../../assets/login-background.png";

const styles = {
  wrapper: {
    minHeight: "100vh",
    backgroundColor: "#0f172a",
    backgroundImage: `url("${Background}")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  panel: {
    background: "#FEF3C7",
    border: "1px solid #FBBF24",
    borderRadius: "12px",
    padding: "32px",
    maxWidth: "520px",
    width: "100%",
    textAlign: "center",
    color: "#92400E",
  },
  icon: {
    fontSize: "32px",
    marginBottom: "12px",
  },
  title: {
    margin: "0 0 12px",
    fontSize: "20px",
  },
  message: {
    margin: 0,
    whiteSpace: "pre-line",
    lineHeight: "1.5",
    fontSize: "14px",
  },
};

const MaintenanceScreen = ({ title, message }) => {
  const resolvedTitle = title || "Portal u održavanju";
  const resolvedMessage =
    message ||
    "Portal trenutno nije dostupan zbog planiranog održavanja. Molimo pokušajte kasnije.";
  const htmlMessage = resolvedMessage.replace(/\n/g, "<br />");

  return (
    <div style={styles.wrapper}>
      <div style={styles.panel}>
        <div style={styles.icon} aria-hidden="true">
          🛠️
        </div>
        <h1 style={styles.title}>{resolvedTitle}</h1>
        <p
          style={styles.message}
          dangerouslySetInnerHTML={{ __html: htmlMessage }}
        />
      </div>
    </div>
  );
};

export default MaintenanceScreen;
